var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ab-wysiwyg",class:[
    _vm.icon ? 'ab-textarea--icon' : '',
    _vm.error ? 'has-error' : '',
    !_vm.error ? 'is-valid' : '',
    _vm.error && _vm.errorMessage ? 'has-message' : ''
  ]},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(!_vm.error && !_vm.errorMessage)?_c('span',{staticClass:"ab-textarea__error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_c('div',{staticClass:"ab-wysiwyg-editor"},[_c('froala',{attrs:{"tag":'textarea',"config":_vm.config},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_c('label',[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }